import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2">
            <h1 className="text-4xl font-bold text-gray-900">ChecksAndTicks</h1>
            <span className="px-2 py-0.5 text-xs font-semibold bg-yellow-100 text-yellow-800 rounded-full uppercase tracking-wide">Beta</span>
          </div>
          <p className="text-gray-600 mt-2">Asset & Checklist Management</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
